import React, { Component } from "react";
import project from "../config";
const projectLogo = require(`../assets/${project.assets}/img/projectLogo.png`);

class Loading extends Component {
	state = {};

	render() {
		let {
			initializingData,
			isUEFailed,
			isApiFailed,
			unrealStatus,
			loadingProcessValue,
		} = this.props;
		let mainDivClass = "mainLoading";
		let loadingCSS = "loadingSpinner02";
		let backBtnClass = "loadingBackBtn hide";
		let progressClass = "";
		let messageText;

		switch (unrealStatus) {
			case "starting":
				messageText = "Kommunikation starten";
				break;
			case "openingMap":
				messageText = "Laden von 3D-Szenen";

				break;
		}

		if (isUEFailed) {
			messageText =
				"Es trat ein Problem mit der Visualisierung auf. Bitte versuchen Sies es später noch einmal.";
			backBtnClass = "loadingBackBtn";
			loadingCSS = "hide";
			progressClass = "hide";
		} else if (isApiFailed) {
			messageText =
				"Es trat ein Problem mit der Server-Verbindung auf. Bitte versuchen Sies es später noch einmal.";
			backBtnClass = "loadingBackBtn";
			loadingCSS = "hide";
			progressClass = "hide";
		} else if (
			initializingData.apiInitialized &&
			initializingData.ueInitialized
		) {
			mainDivClass = "mainLoading hide";
			loadingCSS = "loadingSpinner02";
		}

		return (
			<div className={mainDivClass}>
				<img src={projectLogo} alt="" />
				<div className={loadingCSS}>
					<div className="loadingSpinner">
						<div></div>
					</div>
				</div>
				<progress
					id="loadingProgress"
					max="100"
					value={loadingProcessValue}
					className={progressClass}
				/>
				<span>{messageText}</span>
				{/* <span>{loadingProcessText}</span> */}
				<a href={project.metaURL} className={backBtnClass}>
					zurück
				</a>
			</div>
		);
	}
}

export default Loading;
